import React, { useState, useEffect } from "react";
import Icon from "./ui/Icon";
import EmptyState from "./ui/EmptyState";
import "../styles/AdminExtraFunctions.css";
// SM-AUTH-HR: login token for the fetch calls below. REVERT: delete this
// import and the authHeader() uses.
import { authHeader } from "./axios";

const AdminExtraFunctions = () => {
    const [domainName, setDomainName] = useState("");
    const [empId, setEmpId] = useState("");
    const [years, setYears] = useState("");
    const [months, setMonths] = useState("");
    const [message, setMessage] = useState("");
    const [searchEmpId, setSearchEmpId] = useState("");
    const [pageInput, setPageInput] = useState("");
    const [experienceData, setExperienceData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;
    const [file, setFile] = useState(null);

    const fetchExperience = async () => {
        // SM-AUTH-HR: send the login token. REVERT: back to
        //   const res = await fetch("/api/admin/get-employee-experience");
        // and delete the !res.ok check (it avoids a JSON error on 401).
        const res = await fetch("/api/admin/get-employee-experience", { headers: authHeader() });
        if (!res.ok) return;
        const data = await res.json();
        setExperienceData(data);
    };

    useEffect(() => {
        fetchExperience();
    }, []);

    // Add Skill Domain
    const addDomain = async () => {
        const res = await fetch("/api/admin/add-skill-domain", {
            method: "POST",
            // SM-AUTH-HR: ...authHeader() added. REVERT: delete it.
            headers: { "Content-Type": "application/json", ...authHeader() },
            body: JSON.stringify({ domainName })
        });

        const msg = await res.text();
        setMessage(msg);
        setDomainName("");
    };

    // Add Experience
    const addExperience = async () => {
        const res = await fetch("/api/admin/add-employee-experience", {
            method: "POST",
            // SM-AUTH-HR: ...authHeader() added. REVERT: delete it.
            headers: { "Content-Type": "application/json", ...authHeader() },
            body: JSON.stringify({
                employeeId: empId,
                years: parseInt(years),
                months: parseInt(months)
            })
        });

        const msg = await res.text();
        setMessage(msg);

        setEmpId("");
        setYears("");
        setMonths("");

        fetchExperience(); // refresh table
    };

    // Excel Upload
    const uploadExcel = async () => {
        if (!file) return alert("Please select a file");

        const formData = new FormData();
        formData.append("file", file);

        const res = await fetch("/api/admin/upload-experience-excel", {
            method: "POST",
            // SM-AUTH-HR: send the login token (no Content-Type: the browser
            // sets the multipart boundary itself). REVERT: delete this line.
            headers: authHeader(),
            body: formData
        });

        const msg = await res.text();
        setMessage(msg);

        fetchExperience(); // refresh table
    };

    const filteredData = experienceData.filter(item =>
        item.employeeId
            ?.toLowerCase()
            .includes(searchEmpId.toLowerCase())
    );
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);

    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    return (
        <div className="admin-extra-page">
            <header className="page-head reveal">
                <span className="page-eyebrow">Admin</span>
                <h1 className="page-title-mt">Admin Extra Functions</h1>
                <p className="page-sub">
                    Manage skill domains, employee experience records and bulk uploads.
                </p>
            </header>

            {message && (
                <div className="notice notice-success reveal" role="status">
                    <Icon name="check" size={17} />
                    <span>{message}</span>
                </div>
            )}

            <div className="admin-cards-grid">
                {/* Add Skill Domain */}
                <section className="card-mt card-pad reveal reveal-d1">
                    <h3 className="card-title-mt">
                        <span className="card-title-icon"><Icon name="layers" size={16} /></span>
                        Add Skill Domain
                    </h3>

                    <div className="admin-field">
                        <label className="field-label" htmlFor="admin-domain-name">Domain name</label>
                        <input
                            id="admin-domain-name"
                            className="input-mt"
                            placeholder="e.g. Embedded Systems"
                            value={domainName}
                            onChange={(e) => setDomainName(e.target.value)}
                        />
                    </div>

                    <button onClick={addDomain} className="btn btn-primary-mt admin-card-action">
                        Add Domain
                    </button>
                </section>

                {/* Add Experience */}
                <section className="card-mt card-pad reveal reveal-d2">
                    <h3 className="card-title-mt">
                        <span className="card-title-icon"><Icon name="briefcase" size={16} /></span>
                        Add Employee Experience
                    </h3>

                    <div className="admin-field">
                        <label className="field-label" htmlFor="admin-exp-empid">Employee ID</label>
                        <input
                            id="admin-exp-empid"
                            className="input-mt"
                            placeholder="e.g. MT01234"
                            value={empId}
                            onChange={(e) => setEmpId(e.target.value)}
                        />
                    </div>

                    <div className="admin-field-row">
                        <div className="admin-field">
                            <label className="field-label" htmlFor="admin-exp-years">Years</label>
                            <input
                                id="admin-exp-years"
                                className="input-mt num"
                                inputMode="numeric"
                                placeholder="0"
                                value={years}
                                onChange={(e) => setYears(e.target.value)}
                            />
                        </div>
                        <div className="admin-field">
                            <label className="field-label" htmlFor="admin-exp-months">Months</label>
                            <input
                                id="admin-exp-months"
                                className="input-mt num"
                                inputMode="numeric"
                                placeholder="0"
                                value={months}
                                onChange={(e) => setMonths(e.target.value)}
                            />
                        </div>
                    </div>

                    <button onClick={addExperience} className="btn btn-primary-mt admin-card-action">
                        Add Experience
                    </button>
                </section>

                {/* Excel Upload */}
                <section className="card-mt card-pad reveal reveal-d3">
                    <h3 className="card-title-mt">
                        <span className="card-title-icon"><Icon name="upload" size={16} /></span>
                        Upload Experience Excel
                    </h3>

                    <div className="admin-field">
                        <label className="field-label" htmlFor="admin-excel-file">Excel file (.xlsx)</label>
                        <input
                            id="admin-excel-file"
                            className="admin-file-input"
                            type="file"
                            onChange={(e) => setFile(e.target.files[0])}
                        />
                    </div>

                    <button onClick={uploadExcel} className="btn btn-primary-mt admin-card-action">
                        <Icon name="upload" size={16} />
                        Upload Excel
                    </button>
                </section>
            </div>

            {/* Experience table */}
            <section className="card-mt reveal reveal-d4">
                <div className="admin-table-toolbar">
                    <h3 className="card-title-mt admin-table-title">
                        <span className="card-title-icon"><Icon name="list" size={16} /></span>
                        Employee Experience Table
                    </h3>

                    <div className="admin-search">
                        <label className="field-label" htmlFor="admin-search-empid">Search by Employee ID</label>
                        <div className="admin-search-wrap">
                            <Icon name="search" size={16} className="admin-search-icon" />
                            <input
                                id="admin-search-empid"
                                className="input-mt admin-search-input"
                                placeholder="Search…"
                                value={searchEmpId}
                                onChange={(e) => {
                                    setSearchEmpId(e.target.value);
                                    setCurrentPage(1); // reset page on search
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="table-wrap">
                    <table className="table-mt">
                        <thead>
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Employee ID</th>
                                <th scope="col">Years</th>
                                <th scope="col">Months</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((item) => (
                                    <tr key={item.id}>
                                        <td className="num">{item.id}</td>
                                        <td className="num">{item.employeeId}</td>
                                        <td className="num">{item.years}</td>
                                        <td className="num">{item.months}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4">
                                        <EmptyState
                                            icon="briefcase"
                                            title="No experience records"
                                            text="Add an employee's previous experience above, or upload an Excel file."
                                        />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {totalPages > 1 && (
                    <div className="team-pagination">
                        <span className="team-pagination-info num">
                            Page {currentPage} of {totalPages}
                        </span>
                        <div className="team-pagination-controls">
                            <button
                                type="button"
                                className="icon-btn"
                                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                disabled={currentPage === 1}
                                aria-label="Previous page"
                            >
                                <Icon name="chevronLeft" size={17} />
                            </button>

                            <span className="num team-page-indicator">
                                {currentPage} / {totalPages}
                            </span>

                            <button
                                type="button"
                                className="icon-btn"
                                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                disabled={currentPage === totalPages}
                                aria-label="Next page"
                            >
                                <Icon name="chevronRight" size={17} />
                            </button>

                            <label className="sr-only" htmlFor="admin-goto-page">Go to page</label>
                            <input
                                id="admin-goto-page"
                                type="number"
                                min="1"
                                max={totalPages}
                                className="input-mt admin-goto-input num"
                                placeholder="Page"
                                value={pageInput}
                                onChange={(e) => setPageInput(e.target.value)}
                            />

                            <button
                                type="button"
                                className="btn btn-secondary-mt btn-sm"
                                onClick={() => {
                                    const page = Number(pageInput);
                                    if (page >= 1 && page <= totalPages) {
                                        setCurrentPage(page);
                                    }
                                }}
                            >
                                Go
                            </button>
                        </div>
                    </div>
                )}
            </section>
        </div>
    );
};

export default AdminExtraFunctions;
